import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../footer/footer';
import Header from '../header/header';

const Layout: React.FC<{alt?: boolean}> = props => {
  return (
    <>
      <Header alt={props.alt} />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;